import AppServiceNewApi from "./AppServiceNewApi";

class StatsServiceNewApi extends AppServiceNewApi{
    
    getStats(organizationId, companyId){
        let filterString = '?'
        if(organizationId)filterString = `${filterString}organizationId=${organizationId}`
        if(companyId)filterString = `${filterString}companyId=${companyId}`
        if(filterString === '?')filterString = ''
        else filterString = filterString.substring(0, filterString?.length)
        const url = `/api/internal/v1/stats${filterString}`
        return this.http.get(`${url}`)
    }

    getStatsToggle(organizationId){
        const url = `/api/internal/v1/stats/by-month?organizationId=${organizationId}`
        return this.http.get(`${url}`)
    }
    
    getMissingEmployeeData(organizationId){
        const url = `/api/internal/v1/stats/empty-companies?organizationId=${organizationId}`
        return this.http.get(`${url}`)
    }

    getStatsCompletedLastMonth(organizationId, days){
        const url = `/api/internal/v1/stats/completed-surveys?organizationId=${organizationId}&passedDays=${days}`
        return this.http.get(`${url}`)
    }

}
export default StatsServiceNewApi